import React, { useContext } from "react";
import { FirstHeader } from "../../components/sharedComponents/FirstHeader";
import { CallAPI } from "../../config/api/ApiConfig";
import { LocaleContext } from "../../config/localization/LanguageProvider";

export const PrivacyPolicy = () => {
  const { locale } = useContext(LocaleContext);

  const { data: about } = CallAPI({
    name: "privacyPolicy",
    url: "/mentor/v1/page/privacy_policy",
    refetchOnWindowFocus: false,
    enabled: true,
    select: (res) => res?.data?.data,
    // onError: (err) => toast.error(err?.response?.data),
  });
  const ff = "<h2> dddd </h2>";
  return (
    <div className="terms">
      <>
        <FirstHeader
          className="terms__header"
          text={locale === "ar" ? about?.name_ar : about?.name_en}
        />
      </>

      <div
        className="terms__content"
        style={{ color: "var(--text-color)" }}
        dangerouslySetInnerHTML={{
          __html: locale === "ar" ? about?.body_ar : about?.body_en,
        }}
      ></div>
    </div>
  );
};
